import { QueryClient } from "@tanstack/react-query";
import { shouldRetry } from "./queryPolicy";
import { CATALOGUE_CACHE_MS, SEARCH_FRESH_MS } from "./catalogueCache";

/** The query client the app and the site each start with, one a page load. */
export function appQueryClient(): QueryClient {
    const client = new QueryClient({
        defaultOptions: {
            queries: {
                // One person's data on one machine. A page that is open is
                // usually being read, and the boards are checked all day behind it,
                // so a refetch on focus is how the queue stays current.
                staleTime: 15_000,
                refetchOnWindowFocus: true,
                // A refusal is shown at once; what may pass is tried again.
                retry: shouldRetry,
            },
        },
    });
    // Public jobs change more slowly than a person's queue. Retain them across navigation.
    client.setQueryDefaults(["catalogue"], {
        staleTime: SEARCH_FRESH_MS,
        gcTime: typeof window === "undefined" ? Infinity : CATALOGUE_CACHE_MS,
    });
    client.setQueryDefaults(["catalogue", "status"], { staleTime: 60_000 });
    return client;
}
